/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-03 15:13:43
 */
export const subjectData = [
  { id: 1, name: "预防保健科" },
  { id: 2, name: "全科医疗科" },
  { id: 3, name: "内科" },
  { id: 4, name: "外科" },
  { id: 5, name: "儿科" },
  { id: 6, name: "妇产科" },
  { id: 7, name: "眼科" },
  { id: 8, name: "耳鼻咽喉科" },
  { id: 9, name: "口腔科" },
  { id: 10, name: "皮肤科" },
  { id: 11, name: "医疗美容科" },
  { id: 12, name: "精神科" },
  { id: 13, name: "传染科" },
  { id: 14, name: "结核病科" },
  { id: 15, name: "地方病科" },
  { id: 16, name: "肿瘤科" },
  { id: 17, name: "急诊医学科" },
  { id: 18, name: "康复医学科" },
  { id: 19, name: "运动医学科" },
  { id: 20, name: "职业病科" },
  { id: 21, name: "麻醉科" },
  { id: 22, name: "重症医学科" },
  { id: 23, name: "中医科" },
  { id: 24, name: "民族医学科" },
  { id: 25, name: "中西医结核科" },
  { id: 26, name: "感染性疾病科" },
  { id: 27, name: "老年病科" },
  { id: 28, name: "医学检验科" },
  { id: 29, name: "医学影像科" },
  { id: 30, name: "病理科" },
  { id: 31, name: "药剂科" },
  { id: 32, name: "输血科" },
  { id: 33, name: "临床营养科" },
  { id: 34, name: "其他" },
];
